import { useEffect, useState } from 'react';

import { Box, SimpleGrid } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';

import { TextInput, Title } from 'components';
import { CreditOptionsResponse, CreditRequestForm, CreditResponse } from 'types';

import CreditRequestEmployment from './employment';
import CreditRequestIncome from './income';

interface CreditRequestIncomesProps {
  credit: CreditResponse;
  form: UseFormReturnType<CreditRequestForm>;
  options: CreditOptionsResponse;
  readOnly?: boolean;
}

const CreditRequestIncomes = ({ credit, form, options, readOnly = false }: CreditRequestIncomesProps) => {
  const { t } = useTranslation();

  const [partnerIncludeInApplication, setPartnerIncludeInApplication] = useState<boolean | undefined>(credit.partnerIncludeInApplication);

  useEffect(() => {
    const formValues = form.getValues();
    if (Object.keys(formValues).length === 0) {
      return;
    }
    const include = formValues.partnerIncludeInApplication;
    if (!include) {
      const employments = credit['employments'] ? credit['employments'].filter(el => !el.partner) : [];
      const incomes = credit['incomes'] ? credit['incomes'].filter(el => !el.partner) : [];
      form.setFieldValue('employments', employments);
      form.setFieldValue('incomes', incomes);
    }
    setPartnerIncludeInApplication(include);
  }, [form.getValues().partnerIncludeInApplication]);

  return (
    <Box>
      <Box mb={40}>
        <Title order={5} px={'md'} mb={'sm'} c={'var(--mantine-color-primary-6)'}>{t('credit.employment.title')}</Title>
        <CreditRequestEmployment credit={credit} form={form} options={options} partner={false} readOnly={readOnly} />
      </Box>
      <Box mt={'md'} mb={40}>
        <Title order={5} px={'md'} mb={'sm'} c={'var(--mantine-color-primary-6)'}>{t('credit.income.title')}</Title>
        <CreditRequestIncome credit={credit} form={form} options={options} partner={false} readOnly={readOnly} />
      </Box>
      {partnerIncludeInApplication &&
        <>
          <Box mt={'md'} mb={40}>
            <Title order={5} px={'md'} mb={'sm'} c={'var(--mantine-color-primary-6)'}>{t('credit.employment.partner.title')}</Title>
            <CreditRequestEmployment credit={credit} form={form} options={options} partner={true} readOnly={readOnly} />
          </Box>
          <Box mt={'md'} mb={40}>
            <Title order={5} px={'md'} mb={'sm'} c={'var(--mantine-color-primary-6)'}>{t('credit.income.partner.title')}</Title>
            <CreditRequestIncome credit={credit} form={form} options={options} partner={true} readOnly={readOnly} />
          </Box>

          <Box mt={'md'} p={'md'}>
            <SimpleGrid cols={4}>
              <TextInput
                label={t('credit.comment.singular')}
                key={form.key('comment3')}
                {...form.getInputProps('comment3')}
                disabled={readOnly}
              />
            </SimpleGrid>
          </Box>
        </>
      }
    </Box>
  )
}

export default CreditRequestIncomes;